import _has from 'lodash/has';

export default class DialogErrorController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    error
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.error = error;
    if (_has(this.error, 'details') && this.error.details.length > 0) {
      this.contentError = this.getContent(this.error.details);
    }
  }

  getContent(details) {
    let message = '';
    for (const item of details) {
      if (item.errors.length > 0) {
        return this.getContent(item.errors);
      }

      message = item.message;
    }

    return message;
  }

  hide() {
    this.$mdDialog.hide();
  }
}
